import React from "react";

import StepperList from "../../../../components/StepperList";

const STEPS = [ "Site & Urls", "Template", "Actions", "Data", "Done" ];

const StepperActions = ({ activeStep, skipped = new Set() }) => (
    <StepperList
        activeStep={activeStep}
        steps={STEPS}
        skipped={skipped}
    />
);

export default StepperActions;
